'use client';
import React from 'react';
import styles from './DefaultFooter.module.scss';
import { BenzingaLogo } from '@benzinga/logos-ui';
import FooterLink from '../../FooterLink';
import SocialIcon from '../../SocialIcon';
import AppStoreButton from '../../AppStoreButton';
import { isMobile } from '@benzinga/device-utils';
import { FooterStickyNav } from '../../FooterStickyNav';

import {
  aboutBenzinga,
  AppStore,
  copyrightSection,
  FooterLink as IFooterLink,
  partnersAndContributors,
  popularChannels,
  socialSites,
  toolsAndFeatures,
  appStores,
} from '../../footerEntity';

import { NavigationFooterProps } from '../..';

export const DefaultFooter: React.FC<NavigationFooterProps> = ({
  showAppList = true,
  showFooterLinksTable = true,
  showStickyFooter,
  socialMedia = {},
}) => {
  const isAmp = false;
  const year = new Date().getFullYear();
  const footerLogo = <BenzingaLogo />;
  const copyrightLinks = copyrightSection;

  const renderFooterLinks = (links: IFooterLink[]) =>
    links.map(({ label, url }) => <FooterLink key={label} label={label} url={url} />);

  const socialSitesList =
    Object.keys(socialMedia).length > 0
      ? Object.keys(socialMedia).map((site: string) => {
          const socialSitesProps = {
            ...socialSites[site],
            ...socialMedia[site],
          };

          return <SocialIcon {...socialSitesProps} isAmp={isAmp} key={socialSitesProps.name} />;
        })
      : Object.keys(socialSites).map((site: string) => {
          const socialSitesProps = socialSites[site];
          return <SocialIcon {...socialSitesProps} isAmp={isAmp} key={socialSitesProps.name} />;
        });

  const AppList = Object.values(appStores).map((appStore: AppStore) => (
    <AppStoreButton icon={appStore.icon} key={appStore.name} name={appStore.name} storeUrl={appStore.link} />
  ));

  return (
    <>
      <div className={isMobile() ? 'footer has-sticky-nav' : 'footer'}>
        <div className="footer-top-section">
          <div className="benzinga-links-section">
            <div className="logo-and-socials-wrapper">
              {footerLogo}
              <div className="social-sites-list">{socialSitesList}</div>
            </div>
            {showAppList && <div className="app-store-wrapper">{AppList}</div>}
          </div>
          {showFooterLinksTable && (
            <div className={`${styles.footerRow} footer-row`}>
              <div className={styles.footerColumn}>
                <h3>Popular Channels</h3>
                <ul>{renderFooterLinks(popularChannels)}</ul>
              </div>
              <div className={styles.footerColumn}>
                <h3>Tools &amp; Features</h3>
                <ul>{renderFooterLinks(toolsAndFeatures)}</ul>
              </div>
              <div className={styles.footerColumn}>
                <h3>Partners &amp; Contributors</h3>
                <ul>{renderFooterLinks(partnersAndContributors)}</ul>
              </div>
              <div className={styles.footerColumn}>
                <h3>About Benzinga</h3>
                <ul>{renderFooterLinks(aboutBenzinga)}</ul>
              </div>
            </div>
          )}
        </div>
        <div className="footer-bottom-section footer-bottom-common">
          <ul>{renderFooterLinks(copyrightLinks)}</ul>
          <div className="copyright-section text-center w-full whitespace-nowrap mt-2">
            &copy; {year} Benzinga | All Rights Reserved
          </div>
        </div>
      </div>
      {isMobile() && showStickyFooter && <FooterStickyNav />}
    </>
  );
};

export default DefaultFooter;
